<template>
  <el-form-item :label="i18nt('designer.setting.defaultValue')">
    <el-input type="text" v-model.trim="optionModel.defaultValue" :placeholder="optionModel.defaultValuePlaceholder || ''"
      @change="emitDefaultValueChange"></el-input>
  </el-form-item>
</template>

<script>
import i18n from "@/utils/i18n"
import propertyMixin from "@/components/form-designer/setting-panel/property-editor/propertyMixin"

export default {
  name: "ntDefaultValue-editor",
  mixins: [i18n, propertyMixin],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object,
  },
}
</script>

<style scoped></style>
